// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".JobSeriesDetailsPanel-base__mGlLN{display:flex;flex-direction:column;gap:var(--size-4)}.JobSeriesDetailsPanel-detailsContent__LHNjb{display:flex;flex-direction:column;gap:var(--size-4);padding:var(--size-4)}.JobSeriesDetailsPanel-createdByValue__tRaNF{display:flex;gap:var(--size-2);align-items:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "JobSeriesDetailsPanel-base__mGlLN",
	"detailsContent": "JobSeriesDetailsPanel-detailsContent__LHNjb",
	"createdByValue": "JobSeriesDetailsPanel-createdByValue__tRaNF"
};
export default ___CSS_LOADER_EXPORT___;
